document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () { mobileMenu.classList.remove('is-open'); });
  });
  if (menuToggle) {
    menuToggle.addEventListener('click', function () { mobileMenu.classList.add('is-open'); });
  }

  /* ---------- Search panel ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      if (searchPanel.classList.contains('is-open')) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  function openCart() { if (cartDrawer) cartDrawer.classList.add('is-open'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('is-open'); }
  if (cartToggle) cartToggle.addEventListener('click', openCart);
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCart);
  });

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer-contents')
      .catch(function () {});
    // Simpler: refetch cart.js for count, and re-render body via section render URL
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/cart')
      .catch(function () {});
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
    // Reload the cart body markup via the cart page's rendered snippet through Section Rendering API
    fetch(location.pathname + '?section_id=cart-drawer-body-refresh')
      .catch(function () {});
    // Fallback: simplest reliable approach is a full drawer content refetch from /cart?view=drawer if a drawer alt-template/section exists.
    // For guaranteed correctness across all stores, we just reload cart.js totals and ask the page to re-render on next open via location cache-bust:
    var body = document.getElementById('CartDrawerBody');
    if (body) {
      fetch('/cart?section_id=main-cart')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newBody = doc.getElementById('CartDrawerBody');
          if (newBody) body.innerHTML = newBody.innerHTML;
          bindDynamicCartEvents();
        })
        .catch(function () {});
    }
  }

  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* Quick add buttons on product cards */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      btn.textContent = 'Adding...';
      addToCart(variantId, 1).then(function () {
        btn.textContent = 'Added ✓';
        refreshCartDrawer();
        openCart();
        setTimeout(function () { btn.textContent = '+ Quick Add'; }, 1800);
      }).catch(function () {
        btn.textContent = 'Unavailable';
        setTimeout(function () { btn.textContent = '+ Quick Add'; }, 1800);
      });
    });
  });

  /* Product form add to cart (AJAX) */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = productForm.querySelector('[data-variant-id]').value;
      var qty = parseInt(productForm.querySelector('[data-qty-input]').value, 10) || 1;
      var addBtn = productForm.querySelector('[data-add-to-cart]');
      var addText = productForm.querySelector('[data-add-to-cart-text]');
      var original = addText.textContent;
      addText.textContent = 'Adding...';
      addToCart(variantId, qty).then(function () {
        addText.textContent = 'Added ✓';
        refreshCartDrawer();
        openCart();
        setTimeout(function () { addText.textContent = original; }, 1800);
      }).catch(function () {
        addText.textContent = 'Could not add';
        setTimeout(function () { addText.textContent = original; }, 1800);
      });
    });

    var buyNow = document.querySelector('[data-buy-now]');
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        var variantId = productForm.querySelector('[data-variant-id]').value;
        var qty = parseInt(productForm.querySelector('[data-qty-input]').value, 10) || 1;
        addToCart(variantId, qty).then(function () {
          window.location.href = '/checkout';
        });
      });
    }
  }

  /* Quantity steppers (generic) */
  function bindDynamicCartEvents() {
    document.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
      btn.onclick = function () {
        var wrap = btn.closest('.qty-stepper');
        var input = wrap.querySelector('[data-qty-input]');
        var val = Math.max((wrap.dataset.lineKey === 'new' ? 1 : 0), (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
        handleQtyChange(wrap, val);
      };
    });
    document.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
      btn.onclick = function () {
        var wrap = btn.closest('.qty-stepper');
        var input = wrap.querySelector('[data-qty-input]');
        var val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
        handleQtyChange(wrap, val);
      };
    });
    document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.onclick = function () {
        changeLine(btn.getAttribute('data-line-key'), 0).then(refreshCartDrawer);
      };
    });
  }
  function handleQtyChange(wrap, val) {
    var key = wrap.getAttribute('data-line-key');
    if (key && key !== 'new') {
      changeLine(key, val).then(refreshCartDrawer);
    }
  }
  bindDynamicCartEvents();

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('.product-form__swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var group = swatch.closest('.product-form__option');
      group.querySelectorAll('.product-form__swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      swatch.classList.add('is-selected');
      var selectedLabel = group.querySelector('[data-option-selected]');
      if (selectedLabel) selectedLabel.textContent = swatch.getAttribute('data-option-value');
      updateSelectedVariant();
    });
  });

  function updateSelectedVariant() {
    var productJsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!productJsonEl) return;
    var product;
    try { product = JSON.parse(productJsonEl.textContent); } catch (e) { return; }
    var selected = [];
    document.querySelectorAll('.product-form__option').forEach(function (group) {
      var active = group.querySelector('.product-form__swatch.is-selected');
      if (active) selected.push(active.getAttribute('data-option-value'));
    });
    var match = product.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return selected.every(function (val, i) { return opts[i] === val; });
    });
    if (!match) return;
    var variantIdInput = document.querySelector('[data-variant-id]');
    if (variantIdInput) variantIdInput.value = match.id;
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl) {
      var html = '<span class="price price--large">' + formatMoney(match.price) + '</span>';
      if (match.compare_at_price && match.compare_at_price > match.price) {
        html = '<span class="price price--sale price--large">' + formatMoney(match.price) + '</span>' +
               '<span class="price price--compare price--large">' + formatMoney(match.compare_at_price) + '</span>';
      }
      priceEl.innerHTML = html;
    }
    var addBtn = document.querySelector('[data-add-to-cart]');
    var addText = document.querySelector('[data-add-to-cart-text]');
    if (addBtn && addText) {
      addBtn.disabled = !match.available;
      addText.textContent = match.available ? 'Add to Cart' : 'Sold Out';
    }
  }
  function formatMoney(cents) {
    return Shopify.formatMoney(cents, theme.moneyFormat);
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = thumb.getAttribute('data-index');
      var gallery = thumb.closest('[data-product-gallery]');
      gallery.querySelectorAll('[data-gallery-slide]').forEach(function (s) { s.classList.remove('is-active'); });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      gallery.querySelector('[data-gallery-slide][data-index="' + index + '"]').classList.add('is-active');
      thumb.classList.add('is-active');
    });
  });

  /* Zoom follow mouse */
  document.querySelectorAll('[data-zoom-image]').forEach(function (img) {
    img.parentElement.addEventListener('mousemove', function (e) {
      var rect = img.parentElement.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  });

  /* ---------- Wishlist (stored locally on the customer's device) ---------- */
  var WISHLIST_KEY = 'hosta_haven_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; });
  }
  saveWishlist(getWishlist());

  document.querySelectorAll('[data-wishlist-add]').forEach(function (btn) {
    var id = btn.getAttribute('data-product-id');
    var list = getWishlist();
    if (list.indexOf(id) > -1) {
      btn.classList.add('is-active');
      btn.querySelector('span') && (btn.textContent = '♥ In Wishlist');
    }
    btn.addEventListener('click', function () {
      var current = getWishlist();
      var idx = current.indexOf(id);
      if (idx > -1) {
        current.splice(idx, 1);
        btn.classList.remove('is-active');
      } else {
        current.push(id);
        btn.classList.add('is-active');
      }
      saveWishlist(current);
    });
  });

  /* ---------- Review form toggle ---------- */
  var reviewToggle = document.querySelector('[data-toggle-review-form]');
  var reviewForm = document.querySelector('[data-review-form]');
  if (reviewToggle && reviewForm) {
    reviewToggle.addEventListener('click', function () {
      reviewForm.hidden = !reviewForm.hidden;
    });
  }

});

/* ==========================================================================
   Motion system
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header shrink on scroll ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (prefersReducedMotion) return; // everything below is purely decorative motion

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Leaf dividers draw in on scroll ---------- */
  var dividers = document.querySelectorAll('.leaf-divider');
  if (dividers.length && 'IntersectionObserver' in window) {
    var dividerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          dividerObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    dividers.forEach(function (el) { dividerObserver.observe(el); });
  }

  /* ---------- Icon draw-in (Why Choose Us) ---------- */
  var drawIcons = document.querySelectorAll('[data-icon-draw]');
  drawIcons.forEach(function (wrap) {
    var shapes = wrap.querySelectorAll('svg path, svg circle, svg polyline');
    shapes.forEach(function (shape) {
      var len = 0;
      try { len = shape.getTotalLength(); } catch (e) { len = 100; }
      shape.style.strokeDasharray = len;
      shape.style.strokeDashoffset = len;
    });
  });
  if (drawIcons.length && 'IntersectionObserver' in window) {
    var iconObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-drawn');
          iconObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    drawIcons.forEach(function (el) { iconObserver.observe(el); });
  }

  /* ---------- Hero dappled light — follows cursor, drifts on idle ---------- */
  var lightField = document.querySelector('.hero__light-field');
  if (lightField) {
    var lights = lightField.querySelectorAll('.hero__light');
    var hero = document.querySelector('.hero');
    var driftAngle = 0;

    function drift() {
      driftAngle += 0.003;
      lights.forEach(function (light, i) {
        var dx = Math.sin(driftAngle + i * 2) * 14;
        var dy = Math.cos(driftAngle + i * 1.5) * 10;
        if (!light.dataset.hover) {
          light.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        }
      });
      requestAnimationFrame(drift);
    }
    requestAnimationFrame(drift);

    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var xPct = (e.clientX - rect.left) / rect.width - 0.5;
      var yPct = (e.clientY - rect.top) / rect.height - 0.5;
      lights.forEach(function (light, i) {
        light.dataset.hover = 'true';
        var strength = (i + 1) * 22;
        light.style.transform = 'translate(' + (xPct * strength) + 'px,' + (yPct * strength) + 'px)';
      });
    });
    hero.addEventListener('mouseleave', function () {
      lights.forEach(function (light) { delete light.dataset.hover; });
    });
  }

});
